import Vue from 'vue'
import VueRouter from 'vue-router'
import routerHidden from './routerNormal';
Vue.use(VueRouter)

const pageRoutes = []; // 主菜单路由模块
const pageSettingRoutes = []; // 系统菜单路由模块

// 主路由
const files = require.context('./modules', false, /\.js$/);
files.keys().reverse().forEach(key => {
  const item = files(key).default;
  pageRoutes.unshift(item);
})
// 系统路由
const systemFiles = require.context('./module-setting', false, /\.js$/);
systemFiles.keys().reverse().forEach(key => {
  const item = systemFiles(key).default;
  pageSettingRoutes.unshift(item);
})
/** 常规路由 */
const normalRoutes = [
  {
    path: '/',
    redirect: '/workspace/welcome',
    hidden: true
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/error/notFound.vue'),
    hidden: true,
    meta: {
      fullPage: true
    }
  },
  {
    path: '/401',
    name: 'NotPermission',
    component: () => import('@/views/error/notPermission.vue'),
    hidden: true,
    meta: {
      fullPage: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true,
    meta: {
      fullPage: true
    }
  },
  {
    path: '/sso',
    name: 'SSO',
    component: () => import('@/views/login/sso.vue'),
    hidden: true,
    meta: {
      fullPage: true
    }
  },
  {
    path: '/three-redirect-url',
    name: 'ThreeRedirectUrl',
    component: () => import('@/views/login/threeRedirectUrl.vue'),
    hidden: true,
    meta: {
      fullPage: true
    }
  },
  {
    path: '/login-error',
    name: 'loginError',
    component: () => import('@/views/error/loginError.vue'),
    hidden: true,
    meta: {
      fullPage: true
    }
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  },
]
const routes = [...pageRoutes, ...pageSettingRoutes, ...normalRoutes, routerHidden]; // 渲染路由
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})
// 重复点击bug
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
}
export {pageRoutes, pageSettingRoutes}
export default router
